import axios from "axios";
import { store } from "../store";
import { logout } from "../auth/authSlice";
import { refreshAccessTokenApi } from "../auth/api";

const API_URL = "/";

export const api = axios.create({
  baseURL: API_URL,
  headers: { "Content-Type": "application/json" },
});

let isRefreshing = false;
let refreshSubscribers: ((token: string) => void)[] = [];

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("accessToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      const refreshToken = localStorage.getItem("refreshToken");
      if (error.config.url.includes("refresh")) {
        store.dispatch(logout());
        return Promise.reject(error);
      }
      if (refreshToken) {
        if (!isRefreshing) {
          isRefreshing = true;

          try {
            const response = await refreshAccessTokenApi(refreshToken);
            localStorage.setItem("refreshToken", response.refresh_token);
            localStorage.setItem("accessToken", response.access_token);
            isRefreshing = false;
            refreshSubscribers.forEach((cb) => cb(response.access_token));
            refreshSubscribers = [];
            error.config.headers.Authorization = `Bearer ${response.access_token}`;
            return axios(error.config);
          } catch {
            isRefreshing = false;
            refreshSubscribers = [];
            store.dispatch(logout());
            return Promise.reject(error);
          }
        } else {
          return new Promise((resolve) => {
            refreshSubscribers.push((token) => {
              error.config.headers.Authorization = `Bearer ${token}`;
              resolve(axios(error.config));
            });
          });
        }
      }
    }

    return Promise.reject(error);
  },
);
